// extracted by mini-css-extract-plugin
module.exports = {"container":"SuccessModal_container__1MSL2","wrapper":"SuccessModal_wrapper__28qJJ","text":"SuccessModal_text__YhAoM"};